let SITE_PATH_PREFIX: string = '';

const setMeetingPlacePrefix = (prefix: string) => {
  SITE_PATH_PREFIX = prefix || 'en';
};
const getMeetingPlacePrefix = () => {
  return SITE_PATH_PREFIX;
};

const DEFAULT_LOCALE: string = 'en';
const LOCALES: string[] = [
  'en',
  'fr',
  'fi',
  'cs',
  'de',
  'zh',
  'sv',
  'hi',
  'es',
  'sv',
  'uk',
  'it',
  'pt',
  'sk',
  'nl',
  'pl',
  'ru',
  'ja',
  'ko',
  'ar',
  'zh-CN',
  'en-GB'];

const getDefaultLocale = () => {
  return DEFAULT_LOCALE;
};

export {
  getMeetingPlacePrefix,
  setMeetingPlacePrefix,
  getDefaultLocale,
  DEFAULT_LOCALE,
  LOCALES
};
